// JavaScript для страницы 404
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для страницы 404
});
